module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Translations', [_c('Theme', {
    staticClass: "app-scaffold",
    attrs: {
      "id": "clear-message-verification"
    }
  }, [_c('v-style', [_vm._v("body {overflow: hidden;}")]), _vm._v(" "), (_vm.isCguModalVisible) ? _c('CguModal') : _vm._e(), _vm._v(" "), _c('AppHeader'), _vm._v(" "), _c('main', {
    class: {
      grid: _vm.grid
    },
    attrs: {
      "id": "main"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('AppFooter')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fa1f5be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app-scaffold.vue
// module id = 3328
// module chunks = 0